import React from "react";
import { Link } from "react-router-dom";
import { Container, PageHeader } from "@/components/common";
import { ArrowRight } from "lucide-react";

const RULES = [
  "Partner/Circle dancers have priority. The line of dance is always anti-clockwise around the outside edge of the floor.",
  "Never step onto the dance floor carrying a drink.",
  "Walk around the edge of the dance floor — never cross through the lines of moving dancers.",
  "Keep phones off the dance floor; they can easily be knocked out of your hand and cause injury.",
  "Move off the dance floor to chat, and speak quietly so you don't disturb teaching. If space is tight, consider leaving the room.",
  "Be helpful and welcoming to newcomers — we were all new once, so be patient.",
  "When dancing near beginners, be mindful and courteous by keeping turns or step variations to a minimum, especially during instruction.",
  "Only start a different dance if there's room and you sense it would be acceptable. Follow instructions for splitting the floor.",
  "Always join at the end of a line if room allows, or start a new line to avoid disrupting moving dancers.",
  "If the floor is crowded, take small steps and enjoy the company — but watch out for collisions!",
  "If you bump into someone, it's nice to apologise whether it's your fault or not.",
  "Don't stop dancing to teach — please leave the dance floor.",
  "Start a dance from the front so others can fall in behind.",
  "Have fun and enjoy yourselves!",
];

export default function DanceFloorEtiquette() {
  return (
    <div>
      <PageHeader eyebrow="On the floor" title="Dance floor etiquette"
        subtitle="A few friendly guidelines that keep our dance floor safe, welcoming and fun for everyone." />
      <Container className="py-10">
        <div className="rounded-2xl border border-[#C85A32]/30 bg-[#FBEBE4] p-5 text-center">
          <p className="font-display text-lg font-bold text-[#B04B26]" data-testid="etiquette-lead">Dance floor etiquette is everyone's responsibility.</p>
        </div>
        <ol className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
          {RULES.map((r, i) => (
            <li key={i} className="flex items-start gap-3 rounded-2xl border border-border bg-card p-5" data-testid={`etiquette-rule-${i + 1}`}>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#C85A32] text-sm font-bold text-white">{i + 1}</span>
              <p className="leading-relaxed text-[#5C4A42]">{r}</p>
            </li>
          ))}
        </ol>
        <div className="mt-10 rounded-2xl bg-[#2D1E18] p-6 text-white sm:flex sm:items-center sm:justify-between">
          <div>
            <h3 className="font-display text-xl font-bold">New to the floor?</h3>
            <p className="mt-1 text-sm text-[#EDE4DA]">Learn the building-block moves first with our step tutorials.</p>
          </div>
          <Link to="/basic-steps" data-testid="etiquette-basic-steps" className="mt-4 inline-flex items-center gap-2 rounded-full bg-[#C85A32] px-5 py-3 font-bold text-white hover:bg-[#B04B26] sm:mt-0">Basic steps <ArrowRight size={16} /></Link>
        </div>
      </Container>
    </div>
  );
}
